import axios, { AxiosResponse } from "axios"
import { ThunkAction, ThunkDispatch } from "redux-thunk"
import { RatesTypes, SET_RATES } from "./actionTypes"

const server = process.env.REACT_APP_SERVER_URL

const setPurchasesMethod = (
    rates: any[]
  ): RatesTypes => ({
    type: SET_RATES,
    payload: rates,
  })

export const fetchRates =
  (
    querySearch: string[] = [],
  ): ThunkAction<Promise<void>, {}, {}, RatesTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, RatesTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        rates: any[]
        // numberOfPages: number
      }> = await axios.get(
        `${server}/finances/rate?${[
          ...querySearch,
        ].join('&')}`
      )
      dispatch(
        setPurchasesMethod(response.data.rates)
      )
    } catch (error) {
      throw error
    }
  }